//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from "../components/NavBar.vue";
import Popular from "../components/Popular.vue";
import FollowsTabs from "../components/FollowsTabs.vue";

export default {
  name: "Followers",
  components: {
    NavBar,
    Popular,
    FollowsTabs,
  },
  data() {
    return {
      isUpdate: false,
      popularUpdate: false,
    };
  },
};
